<template>
	<article class="access-ip-manage">
		<div class="access-ip-manage__section-wrap">
			<managing-section
				:is-table="true"
				v-for="ipTableObj in ipTableData"
				:key="ipTableObj.id"
			>
				<template slot="topBar">
					<div
						class="section__info__left access-ip-manage__table-info"
					>
						{{ ipTableObj.title }}
						<span
							class="access-ip-manage__desc"
							v-if="ipTableObj.desc"
							>{{ ipTableObj.desc }}</span
						>
					</div>
					<div class="section__info__right">
						<button
							class="btn section__info__items"
							type="button"
							@click="add(ipTableObj)"
						>
							추가하기
						</button>
					</div>
				</template>
				<table class="table-main access-ip-manage__ip-table">
					<thead>
						<tr>
							<th>아이피</th>
							<th>등록일</th>
							<th class="access-ip-manage__ip-table__delete-col">
								삭제
							</th>
						</tr>
					</thead>
					<tbody v-if="Array.isArray(ipTableObj.list)">
						<tr
							v-for="item in ipTableObj.list"
							:key="item.idIptables"
						>
							<td>{{ item.ip }}</td>
							<td>{{ parseDate(item.create_date) }}</td>
							<td class="access-ip-manage__ip-table__delete-col">
								<button
									class="btn-delete"
									type="button"
									@click="
										deleteIp(item.idIptables, ipTableObj.id)
									"
								>
									삭제
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</managing-section>
		</div>
		<div class="access-ip-manage__section-wrap">
			<managing-section :is-table="true">
				<template slot="topBar">
					<div
						class="section__info__left access-ip-manage__table-info"
					>
						{{ externalTableData.title }}
					</div>
					<div class="section__info__right">
						<button
							class="btn section__info__items"
							type="button"
							@click="add(externalTableData, registerAdminList)"
						>
							추가하기
						</button>
					</div>
				</template>
				<table class="table-main access-ip-manage__ip-table-external">
					<thead>
						<tr>
							<th>이름</th>
							<th>아이디</th>
							<th>직급</th>
							<th>최근접속일</th>
							<th>등록일</th>
							<th class="access-ip-manage__ip-table__delete-col">
								삭제
							</th>
						</tr>
					</thead>
					<tbody v-if="Array.isArray(externalTableData.list)">
						<tr
							v-for="item in externalTableData.list"
							:key="item.idExternalLogin"
						>
							<td>{{ item.nickName }}</td>
							<td>{{ item.eMail }}</td>
							<td>{{ item.positionText }}</td>
							<td v-html="parseDate(item.last_date, '<br>')"></td>
							<td
								v-html="parseDate(item.create_date, '<br>')"
							></td>
							<td class="access-ip-manage__ip-table__delete-col">
								<button
									class="btn-delete"
									type="button"
									@click="
										deleteIp(
											item.idExternalLogin,
											externalTableData.id
										)
									"
								>
									삭제
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</managing-section>
		</div>
	</article>
</template>

<script>
	import moment from 'moment';
	import ManagingSection from '@/components/layout/ManagingSection.vue';

	export default {
		name: 'AccessIpManage',
		components: { ManagingSection },
		data() {
			return {
				allowList: null,
				denyList: null,
				externalList: null,
				registerAdminList: null,
			};
		},
		computed: {
			ipTableData() {
				return [
					{
						id: 'allow',
						title: '허용 IP',
						desc: '*전체 삭제시 아이피 접속 제한 해제',
						list: this.allowList,
						placeholder: '접속허용 IP를 입력하세요',
						alertMsg: '저장할 IP를 입력해주세요',
					},
					{
						id: 'deny',
						title: '차단 IP',
						list: this.denyList,
						placeholder: '접속차단 IP를 입력하세요',
						alertMsg: '저장할 IP를 입력해주세요',
					},
				];
			},
			externalTableData() {
				return {
					id: 'external',
					title: '외부접속 계정',
					list: this.externalList,
					placeholder: '접속허용 IP를 입력하세요',
					alertMsg: '외부접속을 허용할 관리자를 선택해주세요',
				};
			},
		},
		created() {
			this.getTableData();
		},
		methods: {
			parseDate(date, divider = ' ') {
				return date
					? moment(date, 'YYYYMMDDHHmmss').format(
							`YYYY-MM-DD${divider}HH:mm`
						)
					: '-';
			},
			async getTableData() {
				try {
					const { data } =
						await this.$axiosSupport.get('/admin/iptables');
					this.allowList = data.allow_list;
					this.denyList = data.deny_list;
					this.externalList = data.external_list;
					this.registerAdminList = data.register_admin_list;
				} catch (err) {
					console.error(err);
					alert(
						'목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			add({ id, title, placeholder, alertMsg }, selectList) {
				this.$store.commit('modal/toggleModal', {
					id: 'AddIp',
					contsTitle: title,
					params: { type: id, placeholder, alertMsg, selectList },
				});
			},
			async deleteIp(idIptables, type) {
				try {
					if (!confirm('정말 삭제하시겠습니까?')) return false;
					const params = { type };
					await this.$axiosSupport.delete(
						`/admin/iptables/${idIptables}`,
						{ params }
					);
					location.reload();
				} catch (err) {
					console.error(err);
					alert('삭제하는데 실패했습니다. 개발팀에 문의하세요.');
				}
			},
		},
	};
</script>

<style lang="scss">
	.access-ip-manage__section-wrap {
		float: left;
		width: 50%;
		padding-left: 8px;

		&:first-child {
			padding-left: 0;
			padding-right: 8px;
		}

		@media (max-width: 768px) {
			float: none;
			width: 100%;
			padding-left: 0;

			&:first-child {
				padding-right: 0;
			}
		}
	}

	.access-ip-manage__table-info {
		font-weight: bold;
		font-size: 1.125rem !important;
	}

	.access-ip-manage__desc {
		margin-left: 12px;
		color: $red;
	}

	.access-ip-manage__ip-table {
		table-layout: fixed;
	}

	.access-ip-manage__ip-table-external td {
		white-space: normal;
	}

	.access-ip-manage__ip-table__delete-col {
		width: 86px;
	}
</style>
